var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('img',{attrs:{"src":_vm.imgUrl + '404-error.png',"alt":"顾诚智能"}}),_c('router-link',{staticClass:"back",attrs:{"to":"/"}},[_vm._v("返回首页")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }